import { getAudioBufferFromFile } from './get-audio-buffer-from-file'

/**
 * Calculates the duration of an audio file in seconds
 * @param file - The audio file to calculate duration for
 * @returns Promise that resolves to the duration in seconds
 */
export const getAudioDuration = async (file: File): Promise<number> => {
  try {
    const audioBuffer = await getAudioBufferFromFile(file)
    return audioBuffer.duration
  } catch (error) {
    console.error('Error calculating audio duration:', error)
    return 0
  }
}

/**
 * Calculates the duration of an audio file and formats it as MM:SS
 * @param file - The audio file to calculate duration for
 * @returns Promise that resolves to the formatted duration string
 */
export const getFormattedAudioDuration = async (
  file: File
): Promise<string> => {
  const duration = await getAudioDuration(file)
  const minutes = Math.floor(duration / 60)
  const seconds = Math.floor(duration % 60)
  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}
